import type { EmployeeViewModelWithName } from '../../store/types';
import { sortedByName } from '../../store/utilities';

export function availableEmployees(employees: EmployeeViewModelWithName[], selectedEmployees: string[]) {
  return sortedByName(employees)
    .filter((e) => {
      return (e.status !== 'TERMINATED' || selectedEmployees.includes(e.uuid)) && e.isConfirmedEntity;
    })
    .map((p) => {
      return {
        uuid: p.uuid,
        email: p.email,
        personalIdentifier: p.personalIdentifier,
        firstName: p.firstName,
        lastName: p.lastName,
      };
    });
}
